var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"rechazarCambios",attrs:{"titulo":"Descartar cambios","icon":"rechazar-pedido"},on:{"guardar":_vm.descartar}},[_c('div',{staticClass:"row mx-0 mt-3 justify-center"},[_vm._v(" Está apunto de salir ")]),_c('div',{staticClass:"row mx-0 mb-3 justify-center"},[_vm._v(" ¿Desea descartar los cambios realizados? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }